class ModalElement extends HTMLElement {
  constructor() {
    super();

    this.body = document.body;
    this.modalDialog = this.querySelector('.modal__dialog');
    this.close = this.querySelector('.modal__close');
    this.onOutsideClick = this.handleBodyClick.bind(this);

    this.debouncedOnClick = debounce((event) => {
      this.modalClose(event);
    });

    this.close?.addEventListener('click', this.debouncedOnClick.bind(this));
  }

  modalOpen() {
    this.dispatchEvent(new CustomEvent("modal-open"));
    this.classList.add('d-block');
    this.body.classList.add('overflow-hidden');
    this.body.addEventListener('click', this.onOutsideClick);
  }

  modalClose(event) {
    event.preventDefault();
    this.dispatchEvent(new CustomEvent("modal-close"));
    this.classList.remove('d-block');
    this.body.classList.remove('overflow-hidden');
    this.body.removeEventListener('click', this.onOutsideClick);
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.modalDialog && !this.modalDialog.contains(target)) {
      this.modalClose(event);
    }
  }
}

customElements.define('modal-popup', ModalElement);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}